import { normalizeUrl } from '$lib/utils';

// IDs returned by storage-service. The version nibble is deliberately strict:
// users.avatar is an immutable UUID v7, never a filesystem path or remote URL.
export const UUID_V7_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-7[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function isAvatarStorageId(value) {
  return UUID_V7_PATTERN.test(String(value || '').trim());
}

export function avatarContentUrl(value) {
  const avatar = String(value || '').trim();
  if (!avatar) return '';

  if (isAvatarStorageId(avatar)) {
    return normalizeUrl(`/api/upload/files/${encodeURIComponent(avatar)}/content`);
  }

  // Legacy URL support is read-only. New uploads are UUID v7 only.
  if (/^https?:\/\//i.test(avatar) || avatar.startsWith('/')) {
    return normalizeUrl(avatar);
  }

  return '';
}
